import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import PpcLoadForm from './ppc-load-form';
import PpcLoadDetails from './ppc-load-details';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import { getPpcUserManualLoad } from '../../../../actions/ppc';
import { initialStates } from '../../../../initialStates';

class PpcManualLoad extends Component {
  UNSAFE_componentWillMount() {
    this.userId = +this.props.match.params.userId;
    this.props.dispatch(getPpcUserManualLoad(this.userId));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.load('deep.admin_ppc.management.manual_load', initialStates.admin_ppc.management.manual_load));
    this.props.dispatch({type: 'CLEAR_EDIT_PPC_MANUAL_LOAD'});
  }

  render() {
    return (
      <Container fluid className="ppc-user">
        <Row>
          <Col lg={12}>
            <BackLink href={`/admin/ppc/management/${this.userId}`}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Manual prepaid card load
            </PageTitle>
          </Col>
        </Row>
        <Row className="user-info">
          <Col lg={12}>
            {
              this.props.load.attributes && <PpcLoadDetails load={this.props.load}/>
            }
          </Col>
        </Row>
        {
          this.props.load.attributes && (
            <PpcLoadForm
              load={this.props.load}
              userId={this.userId}
            />
          )
        }
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  load: state.ppc.load,
  fetched: state.ppc.fetched,
  fetching: state.ppc.fetching,
});

export default connect(mapStateToProps)(PpcManualLoad);
